// @ts-nocheck - Type compatibility issue: @p81-common/ui and react-i18next v13 types expect React 18
import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider, RightSideBarProvider, Loading } from '@p81-common/ui';
import '@p81-common/ui/ui.umd.css';
import Layout from 'components/Layout/Layout';
import { Notification as NotificationOld } from 'components/common/shared/Notification/Notification';
import { Notification } from '@p81-common/ui';
import { AuthProvider } from 'contexts/auth-context';
import AuthCallbackProvider from 'components/auth/AuthProvider/AuthProvider';
import ErrorBoundary from 'components/common/ErrorBoundary/ErrorBoundary';
import { ContentProvider } from 'contexts/content-context';
import { RegionProvider } from './contexts/RegionContext';
import { SearchPersistenceProvider } from './contexts/SearchPersistenceContext';
import { apiInit, socketInit } from './utils/jarvisApiClient';
import { injectEnvsScript } from 'env';
import i18nConfigure, { resolveTranslationsVersion } from './utils/i18n';
import * as azureAuthService from './services/azureAuthService';
import './styles/reset.css';
import './App.module.scss';
import { useToggle } from 'react-use';

function App() {
  const [willMount, toggleWillMount] = useToggle(true);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        await injectEnvsScript();
        // Must resolve before i18nConfigure runs (first non-loading render).
        await resolveTranslationsVersion();
        apiInit();
        socketInit();

        // Initialize Azure Auth Service SSO
        await azureAuthService.initialize();

        toggleWillMount(false);
      } catch (error) {
        console.error('App initialization failed:', error);
        toggleWillMount(false);
      }
    };

    initializeApp();
  }, [toggleWillMount]);

  return (
    <ThemeProvider>
      {willMount ? (
        <Loading />
      ) : (
        <ErrorBoundary>
          <AuthProvider>
            <I18nextProvider
              i18n={i18nConfigure({
                loadPath: '/translations/{{lng}}/{{ns}}.json'
              })}
            >
              <BrowserRouter>
                <AuthCallbackProvider>
                  <RegionProvider>
                    <ContentProvider>
                      <RightSideBarProvider>
                        <SearchPersistenceProvider>
                          <Layout />
                        </SearchPersistenceProvider>
                        <Notification />
                        <NotificationOld />
                      </RightSideBarProvider>
                    </ContentProvider>
                  </RegionProvider>
                </AuthCallbackProvider>
              </BrowserRouter>
            </I18nextProvider>
          </AuthProvider>
        </ErrorBoundary>
      )}
    </ThemeProvider>
  );
}

// P81-140694: dummy commit — no functional change.
export default App;
